module.exports = __webpack_public_path__ + "img/sarah_broecker_4.8e1c685b.jpg";